import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { style: {"position":"relative","z-index":"20"} }
const _hoisted_2 = { style: {"position":"relative","z-index":"10"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_date_picker = _resolveComponent("v-date-picker")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_title, { class: "bg-blue-grey-lighten-5 text-primary" }, {
        default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
          _createTextVNode(" 欠席連絡 ", -1)
        ]))]),
        _: 1
      }),
      _createVNode(_component_v_form, { ref: "post_absence_form" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_text, { class: "py-3" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_dialog, {
                modelValue: _ctx.isDatePicker,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.isDatePicker) = $event)),
                width: "auto",
                "scroll-strategy": "block"
              }, {
                activator: _withCtx(({ props }) => [
                  _createElementVNode("div", _mergeProps(props, { class: "ios-click-barrier" }), [
                    _createVNode(_component_v_text_field, {
                      modelValue: _ctx.dateRangeText,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dateRangeText) = $event)),
                      label: "期間",
                      "prepend-icon": "mdi-calendar",
                      rules: [_ctx.rules.required],
                      variant: "outlined",
                      density: "compact",
                      readonly: "",
                      inputmode: "none",
                      tabindex: "-1",
                      class: "pointer-events-none"
                    }, null, 8, ["modelValue", "rules"])
                  ], 16)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_v_date_picker, {
                    modelValue: _ctx.dates,
                    "onUpdate:modelValue": [
                      _cache[2] || (_cache[2] = ($event: any) => ((_ctx.dates) = $event)),
                      _ctx.handleDateUpdate
                    ],
                    locale: "ja",
                    min: _ctx.allowMinDate,
                    title: "",
                    multiple: "range",
                    "view-mode": "month",
                    elevation: "12",
                    class: "rounded-lg",
                    color: "primary"
                  }, {
                    actions: _withCtx(() => [
                      _createVNode(_component_v_spacer),
                      _createVNode(_component_v_btn, {
                        variant: "text",
                        color: "primary",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isDatePicker = false))
                      }, {
                        default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                          _createTextVNode(" OK ", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue", "min", "onUpdate:modelValue"])
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _cache[9] || (_cache[9] = _createElementVNode("div", { class: "mt-4" }, null, -1)),
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_v_select, {
                  modelValue: _ctx.selectedReason,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedReason) = $event)),
                  items: _ctx.reasonOptions,
                  "item-title": "title",
                  "item-value": "value",
                  rules: [_ctx.rules.required],
                  label: "理由",
                  variant: "outlined",
                  density: "compact",
                  "menu-props": { contentClass: 'bg-white elevation-8' }
                }, null, 8, ["modelValue", "items", "rules"])
              ]),
              _cache[10] || (_cache[10] = _createElementVNode("div", { class: "mt-2" }, null, -1)),
              _createElementVNode("div", _hoisted_2, [
                (_ctx.selectedReason === 'infection')
                  ? (_openBlock(), _createBlock(_component_v_select, {
                      key: 0,
                      modelValue: _ctx.infection,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.infection) = $event)),
                      items: _ctx.infectionOptions,
                      "item-title": "title",
                      "item-value": "value",
                      rules: [_ctx.rules.required],
                      label: "詳細",
                      variant: "outlined",
                      class: "infection-select",
                      "menu-props": { 
              contentClass: 'bg-white elevation-8 infection-select-menu'
            },
                      density: "compact"
                    }, null, 8, ["modelValue", "items", "rules"]))
                  : _createCommentVNode("", true)
              ]),
              _cache[11] || (_cache[11] = _createElementVNode("div", { class: "mt-2" }, null, -1)),
              (_ctx.selectedReason === 'others')
                ? (_openBlock(), _createBlock(_component_v_textarea, {
                    key: 0,
                    modelValue: _ctx.comment,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.comment) = $event)),
                    rules: [_ctx.rules.required, _ctx.rules.counter500],
                    label: "コメント",
                    variant: "outlined",
                    density: "compact"
                  }, null, 8, ["modelValue", "rules"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_v_divider),
          _createVNode(_component_v_card_actions, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                onClick: _ctx.close,
                color: "error",
                variant: "text"
              }, {
                default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                  _createTextVNode(" キャンセル ", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"]),
              _cache[14] || (_cache[14] = _createElementVNode("div", { style: {"width":"16px"} }, null, -1)),
              _createVNode(_component_v_btn, {
                onClick: _ctx.clickPost,
                loading: _ctx.btnLoading,
                color: "primary",
                variant: "flat"
              }, {
                default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                  _createTextVNode(" 送信 ", -1)
                ]))]),
                _: 1
              }, 8, ["onClick", "loading"]),
              _createVNode(_component_v_spacer)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 512)
    ]),
    _: 1
  }))
}